export const initialState = {
  assetStatusLoading: false,
  assetStatusSuccess: false,
  assetStatusError: false,
  assetStatusCount: 0,
  assetStatusList: [],
};
